ui-cms-anchor {
  display: block;

  ui-icon {
    width: 24px;
    height: 24px;
  }

  span {
    display: flex;
    align-items: center;
  }
}
